import { render } from "./CouponModal.vue?vue&type=template&id=6da0b476"
import script from "./CouponModal.vue?vue&type=script&lang=js"
export * from "./CouponModal.vue?vue&type=script&lang=js"
script.render = render

export default script